module.exports = __webpack_public_path__ + "static/media/asb_haz_lev.4f4a45be.png";